module.exports = __webpack_public_path__ + "static/htc-0ffc36ba99701a2fd3cb4a49284d6e12.png";